const STORAGE_KEY = "eternua_confirmation_offline_queue_v1";
const MAX_AGE_MS = 24 * 60 * 60 * 1000;

function readQueue() {
  try {
    const parsed = JSON.parse(window.localStorage.getItem(STORAGE_KEY) || "[]");
    const now = Date.now();
    return Array.isArray(parsed) ? parsed.filter((item) => now - new Date(item.created_at).getTime() < MAX_AGE_MS).slice(-20) : [];
  } catch { return []; }
}

function writeQueue(queue) {
  try { window.localStorage.setItem(STORAGE_KEY, JSON.stringify(queue.slice(-20))); }
  catch { /* Le parcours courant continue même si le stockage privé est indisponible. */ }
}

function identity(configuration) {
  return [window.location.pathname, configuration.universe, configuration.actionKey, configuration.reference || ""].join("|");
}

export function reserveOfflineConfirmation(configuration, createId) {
  const queue = readQueue();
  const key = identity(configuration);
  const existing = queue.find((item) => item.identity === key);
  if (existing) return existing;
  const draft = {
    identity: key,
    idempotency_key: createId(),
    path: window.location.pathname,
    created_at: new Date().toISOString(),
    configuration: {
      universe: configuration.universe,
      actionKey: configuration.actionKey,
      actionLabel: configuration.actionLabel || configuration.unitLabel || "Action Eternua",
      title: configuration.title || "Démarche interrompue",
      reference: configuration.reference || "",
      securityLevel: configuration.securityLevel || "standard",
    },
  };
  writeQueue([...queue, draft]);
  return draft;
}

export function completeOfflineConfirmation(idempotencyKey) {
  writeQueue(readQueue().filter((item) => item.idempotency_key !== idempotencyKey));
}

export function offlineConfirmationsForCurrentPath() {
  const queue = readQueue();
  writeQueue(queue);
  return queue.filter((item) => item.path === window.location.pathname);
}

export function discardOfflineConfirmation(idempotencyKey) {
  completeOfflineConfirmation(idempotencyKey);
}
